import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDeletionModal from '__components/Modals/presets/ConfirmDeletion';

type DeleteSessionModalProps = {
  onHide: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteSessionModal: FC<DeleteSessionModalProps> = ({
  onHide,
  onConfirm,
  isDeleting,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDeletionModal
      show
      onHide={onHide}
      onConfirm={onConfirm}
      disabled={isDeleting}
    >
      {t(
        'Are you sure you want to delete this chat session? This action cannot be undone.'
      )}
    </ConfirmDeletionModal>
  );
};
